import '@skand/ui/style.css';
export { Root } from './components/Root';
export const HASH = import.meta.env.VITE_BUILD_HASH ?? 'UNKNOWN';
